import React from 'react';

import PropTypes from 'prop-types';
import { UncontrolledPopover } from 'reactstrap';
import PopoverMenu from 'components/Popover/PopoverMenu';
import PopoverMenuItem from 'components/Popover/PopoverMenuItem';

import { MODAL_TYPES } from 'constants/sequenceContact';


const ActionsPopover = props => (
  <UncontrolledPopover
    className="zindex-modal popover__volt"
    trigger="legacy"
    placement="left"
    target={props.target}
    delay={0}
    role="tooltip"
  >
    <PopoverMenu>
      <PopoverMenuItem
        onClick={() => props.toggleModal(true, MODAL_TYPES.DELETE_MODAL, props.seqContact)}
        label="Delete"
        color="red"
      />
    </PopoverMenu>
  </UncontrolledPopover>
);


ActionsPopover.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  target: PropTypes.string.isRequired,
  seqContact: PropTypes.shape({
    id: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.shape({
      additional_data: PropTypes.string,
      error_type: PropTypes.string,
    })).isRequired,
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
  }).isRequired,
};


export default ActionsPopover;
